<template>
  <div class="appDowBox">
    <div class="appDown">
      <!-- <p class="line"></p> -->
      <LineConten></LineConten>
      <p :style="{marginBottom:'48px',fontSize:'28px'}">APP下载</p>
      <p
        :style="{fontSize:'14px',textAlign: 'justify',lineHeight:'27px',color:'#999999'}"
      >鲁商通APP是鲁商通正式对外推出的一款独立APP形态产品，用户界面友好，内容丰富，可以为您提供鲁商通所有数字科技产品。下载鲁商通APP，即刻享受。</p>
      <div
        :style="{marginTop:'88px',marginBottom:'110px',display:'flex',justifyContent:'space-between'}"
      >
        <a href="#" class="qrcode">
          <span class="downOne"></span>
          <img class="item qrcode" src="@/assets/images/oneCode.png" />
        </a>
        <a href="#" class="qrcode">
          <span class="downTwo"></span>
          <img class="item qrcode" src="@/assets/images/twoCode.png" />
        </a>
        <a href="#" class="qrcode">
          <span class="downThree"></span>
          <img class="item qrcode" src="@/assets/images/threeCode.jpg" />
        </a>
        <a href="#" class="qrcode">
          <span class="downFour"></span>
          <img class="item qrcode" src="@/assets/images/fourCode.png" />
        </a>
      </div>
    </div>
    <div class="footer">
      <div class="footerBox">
        <div class="iphoneBox">
          <img src="@/assets/images/iphone.png" />
        </div>
        <div class="footContent">
          <div class="footitem">
            <img class="footItemImg" src="@/assets/images/user.png" alt />
            <p>150万+</p>
            <span class="line footerLine"></span>
            <p>用户</p>
          </div>
          <div class="footitem">
            <img class="footItemImg" src="@/assets/images/user.png" alt />
            <p>17</p>
            <span class="line footerLine"></span>
            <p>覆盖城市</p>
          </div>
          <div class="footitem">
            <img class="footItemImg" src="@/assets/images/user.png" alt />
            <p>300+</p>
            <span class="line footerLine"></span>
            <p>店铺合作</p>
          </div>
          <div class="footitem">
            <img class="footItemImg" src="@/assets/images/user.png" alt />
            <p>6000h+</p>
            <span class="line footerLine"></span>
            <p>稳定运行</p>
          </div>
          <!-- <div class="footitem">
            <img class="footItemImg" src="@/assets/images/user.png" alt />
            <p>150万+</p>
            <span class="line footerLine"></span>
            <p>用户</p>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineConten from "@/components/LineContent";
export default {
  components: {
    LineConten,
  },
};
</script>
<style scoped lang="scss">
.appDowBox {
  margin-top: 240px;
  position: relative;
}
.appDown {
  color: #000000;
  margin-left: 54%;
  width: 320px;
  text-align: center;
}
.line {
  width: 20px;
  border-bottom: 2px solid #666666;
  display: inline-block;
  border-radius: 20px;
}
.item {
  // margin-right: 33px;
  width: 160px;
  // width: 100%;
  // width: 45px;
}
.footer {
  width: 100%;
  background-color: #fd5a01;
  // position: relative;
  .footerBox {
    width: 1200px;
    margin: 0 auto;
    .footContent {
      display: flex;
      text-align: center;
      margin-left: 395px;
      justify-content: space-around;
    }
    .iphoneBox {
      position: absolute;
      // width: 170px;
      height: 0;
      padding-bottom: 350px;
      top: -111px;
      img {
        // width: 130%;
        width: 100%;
      }
    }
  }
}
.footitem {
  padding-bottom: 124px;
  padding-top: 73px;
  margin-left: 57px;
  .footItemImg {
    padding-bottom: 8px;
    width: 48px;
  }
  p {
    color: #ffffff;
  }
}
.footerLine {
  border-bottom: 2px solid #ffffff;
  margin-top: 12px;
}
a.qrcode {
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  background: transparent;
  border-radius: 5px 5px;
  span {
    display: inline-block;
    width: 60px;
    height: 60px;
    background-size: contain;
    color: #fff;
  }
  .downOne {
    background: url("../assets/images/one.png") no-repeat center center;
  }
  .downTwo {
    background: url("../assets/images/two.png") no-repeat center center;
  }
  .downThree {
    background: url("../assets/images/three.png") no-repeat center center;
  }
  .downFour {
    background: url("../assets/images/four.png") no-repeat center center;
  }
  &:hover {
    img.qrcode {
      display: block;
    }
  }
}
img.qrcode {
  display: none;
  position: absolute;
  right: 0;
  bottom: 60px;
}
@media (max-width: 767.98px) {
  .appDown {
    display: none;
  }
  .iphoneBox {
    display: none;
  }
  .footer {
    .footerBox {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      // margin: 0;
      .footContent {
        margin: 0;
      }
    }
  }
  .footitem {
    margin-left: 0;
  }
  .appDowBox {
    margin-top: -27px;
  }
}
</style>
<style>
p {
  margin: 0;
  padding: 0;
}
</style>